import axios from '../content/axios';

const SHADE_KEYS = [50, 100, 500, 600, 700, 900];
const CACHE_KEY = 'mpi_brand_color';
const HEX_PATTERN = /^#[0-9A-Fa-f]{6}$/;

function hexToRgb(hex) {
  const clean = hex.replace('#', '');
  const value = parseInt(clean, 16);
  return { r: (value >> 16) & 255, g: (value >> 8) & 255, b: value & 255 };
}

function mix(rgb, target, amount) {
  return {
    r: Math.round(rgb.r + (target.r - rgb.r) * amount),
    g: Math.round(rgb.g + (target.g - rgb.g) * amount),
    b: Math.round(rgb.b + (target.b - rgb.b) * amount),
  };
}

// Derives the full brand shade scale from a single primary color (treated as shade 600),
// lightening toward white for the lighter shades and darkening toward black for the rest —
// reproduces the current hand-picked green scale almost exactly when fed #1F7A3D.
function buildScale(hex) {
  const rgb600 = hexToRgb(hex);
  const white = { r: 255, g: 255, b: 255 };
  const black = { r: 0, g: 0, b: 0 };
  return {
    50: mix(rgb600, white, 0.9),
    100: mix(rgb600, white, 0.78),
    500: mix(rgb600, white, 0.15),
    600: rgb600,
    700: mix(rgb600, black, 0.15),
    900: mix(rgb600, black, 0.45),
  };
}

const toTriple = ({ r, g, b }) => `${r} ${g} ${b}`;

export function applyBrandColor(hex) {
  if (!HEX_PATTERN.test(hex)) return;
  const scale = buildScale(hex);
  const root = document.documentElement;
  SHADE_KEYS.forEach((key) => {
    root.style.setProperty(`--brand-${key}`, toTriple(scale[key]));
  });
}

export function applyCachedBrandColor() {
  const cached = localStorage.getItem(CACHE_KEY);
  if (cached) applyBrandColor(cached);
}

export async function syncBrandColorFromServer() {
  try {
    const res = await axios.get('/api/theme_settings');
    const hex = res?.data?.data?.primary_color;
    if (!hex || !HEX_PATTERN.test(hex)) return;
    if (hex !== localStorage.getItem(CACHE_KEY)) {
      applyBrandColor(hex);
      localStorage.setItem(CACHE_KEY, hex);
    }
  } catch (err) {
    // Network hiccup or endpoint unavailable — keep the default/cached theme, no user-facing error needed.
  }
}
